<template>
  <div class="host-ad">
    <template>
      <Table
        :border="false"
        :columns="columns1"
        :data="list"
        :disabled-hover="false"
        no-data-text="暂无数据"
      >
        <template slot-scope="{ row, index }" slot="title">{{
          row.pjName
        }}</template>
        <template slot-scope="{ row, index }" slot="banner">
          <div style="display: flex; align-items: center; padding: 10px 0">
            <img
              style="width: 100%; height: 72px"
              :src="row.netImg"
              @click="
                visible = true;
                imgurl = row.netImg;
              "
            />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="type">{{
          row.type
        }}</template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff; cursor: pointer" @click="setShow(row)"
            >编辑</span
          >
          <!-- <span style="display: inline-block;padding: 0 5px;">|</span> -->
          <!-- <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip> -->
        </template>
      </Table>
    </template>

    <iModal
      title="查看图片"
      v-model="visible"
      class-name="ad-home-modal"
      width="600px"
      footer-hide
    >
      <div style="width: 100%; height: 100%">
        <img style="width: 100%" :src="imgurl" />
      </div>
    </iModal>

    <div>
      <serviceImgEdit
        :show="editShow"
        v-if="editShow"
        :editInfo="editInfo"
        @finish="init()"
        @close="
          editShow = false;
          editInfo = null;
        "
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import serviceImgEdit from "./service-img-edit.vue";

export default {
  name: "common-service-img",
  data() {
    return {
      list: [],
      columns1: [
        {
          title: "订单名称",
          slot: "title",
          key: "title",
          align: "center",
        },
        {
          title: "订单图片",
          slot: "banner",
          key: "banner",
          align: "center",
        },
        {
          title: "线上/线下",
          slot: "type",
          key: "type",
          align: "center",
        },
        // {
        //   title: "排序",
        //   slot: "showIndex",
        //   key: "showIndex",
        //   align: "center"
        // },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      visible: false,
      imgurl: "",
      editShow: false,
      editInfo: null,
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapActions({
      getGroup: "hostCommonModule/getGroup",
    }),
    async init() {
      this.list = [];
      let req = {
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionInfo.id,
      };
      let list = await this.getGroup(req);
      if (list && list.length) {
        list.map((c) => {
          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.type = c.type;
              this.list.push(d);
            });
          }
        });
      }
    },
    setShow(item) {
      this.editInfo = item;
      this.editShow = true;
    },
  },
  created() {
    // this.init();
  },
  components: {
    serviceImgEdit,
  },
};
</script>

<style lang="scss" scoped>
.host-ad {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
}
</style>
<style lang="scss">
.ad-home-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .ad-home-modal {
    display: block;
    .ivu-modal {
      top: 150px;
    }
  }
}
</style>